import type { BlockKind, BlockRule, BlockStats } from "shared";
import { api } from "./client";

export interface ListBlocksResult {
	blocks: BlockRule[];
	stats: BlockStats;
}

export interface CreateBlockInput {
	kind: BlockKind;
	value: string;
	linkId?: string | null;
	note?: string | null;
}

export async function listBlocks(opts?: {
	linkId?: string;
}): Promise<ListBlocksResult> {
	const params = new URLSearchParams();
	if (opts?.linkId) params.set("linkId", opts.linkId);
	const qs = params.toString();
	return api.get(`/blocks${qs ? `?${qs}` : ""}`);
}

export async function createBlock(
	input: CreateBlockInput,
): Promise<{ block: BlockRule }> {
	return api.post("/blocks", input);
}

export async function deleteBlock(id: string): Promise<void> {
	await api.del(`/blocks/${id}`);
}
